var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"cgqBox"},[_c('div',{staticClass:"cgqBoxTil"},[_vm._v("\n\t\t\t先端部弯曲灵活\n\t\t")]),_c('div',{staticClass:"cgqBoxCen"},[_vm._v("\n\t\t\t精心设计的蛇骨设计使弯曲部半径更小，更适应于人体内小空间的操作\n\t\t")]),_c('div',{staticClass:"cgqBoxSp"},[_c('img',{attrs:{"src":require("@/assets/product/page6/sp.png")}})])])])
}]

export { render, staticRenderFns }